/*
 * klaviyo-trigger.js — open a Klaviyo popup form from any link or button.
 *
 * Usage in the theme: set the href (links) or data-klaviyo-form (buttons) to
 * #klaviyo-<formId>, e.g.
 *   <a href="#klaviyo-Rj4URW">Join the Rat's Nest</a>
 *   <button data-klaviyo-form="Rj4URW">…</button>
 * Clicking it calls Klaviyo's documented openForm API. Falls back to letting
 * the link navigate if Klaviyo's script hasn't loaded for any reason.
 */
(function () {
  window._klOnsite = window._klOnsite || [];

  function extractFormId(el) {
    if (el.dataset && el.dataset.klaviyoForm) return el.dataset.klaviyoForm;
    var href = el.getAttribute && el.getAttribute('href');
    if (href && href.indexOf('#klaviyo-') === 0) return href.slice('#klaviyo-'.length);
    return null;
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('a[href^="#klaviyo-"], [data-klaviyo-form]');
    if (!target) return;
    var formId = extractFormId(target);
    if (!formId) return;
    event.preventDefault();
    try {
      window._klOnsite.push(['openForm', formId]);
    } catch (e) {
      /* no-op — script may not be loaded yet */
    }
  });
})();
